import { TypeIcon } from 'src/components/molecules/BoxStatus';
import { ProofResultEnum, ProofResultPassFail } from 'src/ts/enums';

export const NAME = 'fdeReport';

export type IPROOF_INFO = {
  title: string;
  status: string;
  type: TypeIcon;
  note: string;
};
export const getProofInfo = (): IPROOF_INFO[] => [
  {
    title: 'Uploaded',
    status: 'Uploaded',
    type: 'upload',
    note: ''
  },
  {
    title: ProofResultPassFail.CLEAN,
    status: ProofResultEnum.Clean,
    type: 'success',
    note: 'No indication of editing has been detected.'
  },
  {
    title: ProofResultPassFail.EDITED,
    status: ProofResultEnum.Edited,
    type: 'fail',
    note: 'Snappt has found issues with one or more of the following: any modifications to the document, or differences between known authentic documents of this type.'
  },
  {
    title: 'Insufficient Documentation',
    status: ProofResultEnum.Undetermined,
    type: 'warning',
    note: ''
  }
];
